import React, { createContext, useState, useReducer } from 'react';
import PropTypes from 'prop-types';

const initialState = {
    schema: [],
    visibleFilters: [],
    openFilters: {},
    openQuickFilters: {},
    extraSchema: [],
    updatedDefaultFilters: [],
    quickFilters: [],
    crossSchema: {},
    mappedSchema: {},
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'init':
            return { ...state, ...action.payload };
        case 'openFilters':
            return { ...state, openFilters: action.payload };
        case 'openQuickFilters':
            return { ...state, openQuickFilters: action.payload };
        case 'visibleFilters':
            return { ...state, visibleFilters: action.payload };
        case 'quickFilters':
            return { ...state, quickFilters: action.payload };
        case 'crossFilters':
            return { ...state, crossSchema: action.payload };
        case 'saveConfig':
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

const FiltersContext = createContext();

const FiltersProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [clearFilters, setClearFilters] = useState(false);
    const [withExtraFields, setWithExtraFields] = useState(false);
    const [withActiveAdvancedFilters, setWithActiveAdvancedFilters] = useState(false);

    return (
        <FiltersContext.Provider
            value={{
                clearFilters,
                setClearFilters,
                withExtraFields,
                setWithExtraFields,
                withActiveAdvancedFilters,
                setWithActiveAdvancedFilters,
                state,
                dispatch,
            }}
        >
            {children}
        </FiltersContext.Provider>
    );
};

const FiltersConsumer = FiltersContext.Consumer;

export { FiltersContext, FiltersProvider, FiltersConsumer };

FiltersProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
